import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from '../ui/tooltip';

const TooltipSaveProgress = ({ children }: { children: React.ReactNode }) => {
  const { t } = useTranslation();
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent
          className='w-64'
          sideOffset={8}
          side='top'
          variant='zinc'
        >
          <div className='w-full m-2'>
            <div className='space-y-1'>
              <p className='text-sm'>{t('gamification.toggle_saving_details')}</p>
            </div>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default TooltipSaveProgress;